import React, { FC, useEffect, useState } from 'react'
import './HealthUpdate.scss'

import { useForm } from 'react-hook-form'

import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { ShowTGAlert } from 'Helpers/ShowTGAlert'

const relationships = [
  'Father',
  'Mother',
  'Brother',
  'Sister',
  'Spouse',
  'Partner',
  'Uncle',
  'Aunt',
  'Cousin',
  'Friend',
  'Children',
  'Guardian',
  'Other',
]

interface propsType {
  toggleModal: () => void
  selectedHealth: any
  onSave: (data: HealthUpdate) => Promise<void>
}

export type HealthUpdate = {
  fullName: string
  relationship: string
  dateOfBirth: string
  phoneNumber: string
  email: string
  address?: string
}

const schema = yup.object().shape({
  fullName: yup.string().required('Field is required'),
  relationship: yup.string().required('Field is required'),
  dateOfBirth: yup.string().required('Field is required'),
  phoneNumber: yup
    .string()
    .matches(/^[\d+]+$/, 'Only numbers and + allowed')
    .required('Field is required'),
  email: yup.string().required('Field is required').email('Invalid email format'),
  address: yup.string(),
})

const HealthUpdate: FC<propsType> = ({ toggleModal, selectedHealth, onSave }) => {
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm<HealthUpdate>({
    resolver: yupResolver(schema),
  })

  const { showAlert } = ShowTGAlert()
  const [request, setRequest] = useState(false)

  useEffect(() => {
    if (selectedHealth) {
      reset({
        fullName: selectedHealth.fullName,
        relationship: selectedHealth.relationship,
        dateOfBirth: selectedHealth.dateOfBirth,
        phoneNumber: selectedHealth.phoneNumber,
        email: selectedHealth.email,
        // address: selectedHealth?.address,
      })
    } else {
      reset({
        fullName: '',
        relationship: '',
        dateOfBirth: '',
        phoneNumber: '',
        email: '',
        // address: '',
      })
    }
  }, [selectedHealth, reset])

  const submitNewUserInformation = handleSubmit(async (data) => {
    setRequest(true)
    try {
      await onSave(data)

      toggleModal()
    } finally {
      setRequest(false)
    }
  })
  return (
    <div className='health-update'>
      <form onSubmit={submitNewUserInformation}>
        <div className='form-group'>
          <label htmlFor='fullName' className=''>
            Full Name
          </label>
          <input
            autoComplete='off'
            type='text'
            id='fullName'
            className={`form-control ${errors.fullName ? 'is-invalid' : ''}`}
            {...register('fullName', {})}
          />
          {errors.fullName && <div className='invalid-feedback'>{errors.fullName.message}</div>}
        </div>

        {/* Department */}
        <div className='form-group mt-3'>
          <label htmlFor='relationship' className=''>
            Relationship
          </label>

          <select
            id='relationship'
            className={`form-control ${errors.relationship ? 'is-invalid' : ''}`}
            {...register('relationship', {})}
          >
            <option value=''>Select relationship</option>

            {relationships.map((rel) => (
              <option key={rel} value={rel}>
                {rel}
              </option>
            ))}
          </select>

          {errors.relationship && (
            <div className='invalid-feedback d-block'>{errors.relationship.message}</div>
          )}
        </div>
        <div className='form-group mt-3'>
          <div className='formLine'>
            <label htmlFor='dob' className=''>
              Date of Birth
            </label>

            <input
              type='date'
              id='dob'
              className={`form-control ${errors.dateOfBirth ? 'is-invalid' : ''}`}
              {...register('dateOfBirth', {})}
            />

            {errors.dateOfBirth && (
              <div className='invalid-feedback'>{errors.dateOfBirth.message}</div>
            )}
          </div>
        </div>

        <div className='form-group mt-3'>
          <div className='formLine'>
            <label htmlFor='phone' className=''>
              Phone Number
            </label>

            <input
              autoComplete='off'
              type='text'
              id='phone'
              className={`form-control custom-select ${errors.phoneNumber ? 'is-invalid' : ''}`}
              {...register('phoneNumber', {})}
            />
            {errors.phoneNumber && (
              <div className='invalid-feedback'>{errors.phoneNumber.message}</div>
            )}
          </div>
        </div>

        <div className='form-group mt-3'>
          <div className='formLine'>
            <label htmlFor='email' className=''>
              Email
            </label>

            <input
              autoComplete='off'
              type='text'
              id='email'
              className={`form-control custom-select ${errors.email ? 'is-invalid' : ''}`}
              {...register('email')}
            />
            {errors.email && <div className='invalid-feedback'>{errors.email.message}</div>}
          </div>
        </div>

        <div className='form-group mt-3 d-none'>
          <div className='formLine'>
            <label htmlFor='address' className=''>
              Address
            </label>

            <input
              autoComplete='off'
              type='text'
              id='address'
              className={`form-control custom-select ${errors.address ? 'is-invalid' : ''}`}
              {...register('address')}
            />
            {errors.address && <div className='invalid-feedback'>{errors.address.message}</div>}
          </div>
        </div>

        <div className='form-group mt-4'>
          <button disabled={request} className='btn btn-default-2 w-100' type='submit'>
            Save Details {request && <span className='spinner-border spinner-border-sm'></span>}
          </button>
        </div>
      </form>
    </div>
  )
}

export default HealthUpdate
